<template>
  <div class="row mb-1 mt-4">
    <div class="col-12">
      <div
        class="border rounded"
        :class="theme == 'light' ? 'bg-white' : 'border-info'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-9">
              <h4 class="card-title mb-4">
                {{ $t("dashboards.malware-recapitulation") }} <br /><small
                  class="text-muted"
                  >{{ $t("dashboards.sub-malware-recapitulation") }}
                </small>
              </h4>
            </div>
            <div class="col-3 text-right">
              <b-button
                :variant="
                  charttype == 'treemap' ? 'primary' : 'outline-primary'
                "
                size="sm"
                class="mr-2"
                title="Treemap Chart"
                @click="changeType('treemap')"
              >
                <i
                  class="bx bxs-bx bx-dock-right font-size-24 align-middle"
                ></i>
              </b-button>
              <b-button
                :variant="charttype == 'bar' ? 'primary' : 'outline-primary'"
                size="sm"
                title="Bar Chart"
                @click="changeType('bar')"
              >
                <i
                  class="bx bxs-bar-chart-square font-size-24 align-middle"
                ></i>
              </b-button>
            </div>
          </div>
          <div v-if="loading.recap">
            <div class="py-5 my-5">
              <div class="text-center py-4 my-5">
                <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
                <span class="font-size-16"> Loading ... </span>
              </div>
            </div>
          </div>
          <div v-if="!loading.recap && malware_type_series.series[0].data[0]">
            <apexchart
              class="apex-charts"
              height="420"
              :type="charttype"
              :series="malware_type_series.series"
              :options="{
                legend: {
                  show: false,
                },
                colors: [
                  '#3B93A5',
                  '#F7B844',
                  '#ADD8C7',
                  '#EC3C65',
                  '#CDD7B6',
                  '#C1F666',
                  '#D43F97',
                  '#1E5D8C',
                  '#421243',
                  '#7F94B0',
                  '#EF6537',
                  '#C0ADDB',
                ],
                plotOptions: {
                  bar: {
                    distributed: true,
                  },
                  treemap: {
                    distributed: true,
                    enableShades: false,
                  },
                },
                legend: {
                  position: 'bottom',
                },
                fill: {
                  opacity: 1,
                },
                grid: {
                  show: true,
                  strokeDashArray: 0.3,
                  borderColor: '#000', // you can either change hear to disable all grids
                  xaxis: {
                    lines: {
                      show: show, //or just here to disable only x axis grids
                    },
                  },
                  yaxis: {
                    lines: {
                      show: true, //or just here to disable only y axis
                    },
                  },
                },
              }"
            ></apexchart>

            <!-- <apexchart
              class="apex-charts"
              height="415"
              :type="charttype"
              dir="ltr"
              :series="malware_type_series"
              :options="{
                chart: {
                  height: 350,
                  type: 'treemap',
                },
                legend: {
                  show: true,
                  showForSingleSeries: false,
                  showForNullSeries: true,
                  showForZeroSeries: true,
                  position: 'bottom',
                  horizontalAlign: 'center',
                  floating: false,
                  fontSize: '14px',
                  fontFamily: 'Helvetica, Arial',
                  fontWeight: 400,
                  formatter: undefined,
                  inverseOrder: false,
                  width: undefined,
                  height: undefined,
                  tooltipHoverFormatter: undefined,
                  customLegendItems: [],
                  offsetX: 0,
                  offsetY: 0,
                  labels: {
                    colors: '#fff',
                    useSeriesColors: false,
                  },
                  markers: {
                    width: 12,
                    height: 12,
                    strokeWidth: 0,
                    strokeColor: '#fff',
                    fillColors: undefined,
                    radius: 12,
                    customHTML: undefined,
                    onClick: undefined,
                    offsetX: 0,
                    offsetY: 0,
                  },
                  itemMargin: {
                    horizontal: 5,
                    vertical: 4,
                  },
                  onItemClick: {
                    toggleDataSeries: true,
                  },
                  onItemHover: {
                    highlightDataSeries: true,
                  },
                },
                chart: {
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                  redrawOnParentResize: true,
                },
                dataLabels: {
                  enabled: false,
                },
                stroke: {
                  curve: 'smooth',
                  width: [0, 0, 0],
                },
                colors: [
                  '#0c4a6e',
                  '#0369a1',
                  '#0284c7',
                  '#0ea5e9',
                  '#38bdf8',
                  '#7dd3fc',
                  '#bae6fd',
                ],
                xaxis: {
                  categories: malware_type,
                },
                grid: {
                  show: true,
                  strokeDashArray: 0.3,
                  borderColor: '#000',
                  xaxis: {
                    lines: {
                      show: false,
                    },
                  },
                  yaxis: {
                    lines: {
                      show: true,
                    },
                  },
                },
              }"
            ></apexchart> -->
          </div>
          <div v-if="!loading.recap && !malware_type_series.series[0].data[0]">
            <div class="m-5 p-5">
              <div class="mb-5 pb-4">
                <div class="text-center py-4 my-5">
                  <span class="py-5 my-5">
                    {{ $t("dashboards.data-not-found") }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatisticsService from "@/helpers/statistics.service";
import ElasticService from "@/helpers/elastic.service";
import PreferencesServices from "@/helpers/preferences.service";
import { userService } from "@/helpers/authservice/user.service";
import _ from "lodash";
import moment from "moment";

import { malwareRecapitulation } from "../../router/views/dashboards/data";

export default {
  props: {
    statInterval: {
      type: String,
      default: "1d",
    },
    statSandbox: {
      type: String,
      default: "all",
    },
    startDate: {
      type: String,
      default: "all",
    },
    endDate: {
      type: String,
      default: "all",
    },
  },
  components: {},
  data() {
    return {
      theme: localStorage.getItem("theme"),
      malwareRecapitulation: malwareRecapitulation,
      charttype: "treemap",
      series_all: [],
      malware_type: [],
      malware_type_series: {
        series: [
          {
            name: "Total",
            data: [],
          },
        ],
      },
      category: [
        {
          name: "office_file",
          data: ["ppt", "doc", "pdf", "xlsx"],
        },
        {
          name: "archives",
          data: ["zip", "rar", "tar"],
        },
        {
          name: "enc_key",
          data: ["key", "pfx", "lock", "dll"],
        },
        {
          name: "prog",
          data: ["exe", "apk", "jar", "run", "bin"],
        },
        {
          name: "db",
          data: ["sql", "accdb", "mdb"],
        },
      ],
      malwareRecapitulation: {
        series: [
          {
            name: "Commonly Used Office File Extension (.ppt, .doc, etc)",
            data: [],
          },
          {
            name: "Archives, Media Files (.zip, .rar, .tar, etc)",
            data: [],
          },
          {
            name: "Encryption Keys and Certificates (.key, .pfx, etc)",
            data: [],
          },
          {
            name: "Program Files (.exe, .apk, .jar, etc)",
            data: [],
          },
          {
            name: "Database Files (.sql, .accdb, .mdb, etc)",
            data: [],
          },
          {
            name: "Other Format",
            data: [],
          },
        ],
        categories: [],
      },
      sandBoxData: [],
      loading: {
        recap: false,
      },
      process: {
        ahn: false,
        ckp: false,
      },
      pref_ahn: "",
      pref_cp: "",
    };
  },
  watch: {
    startDate: {
      handler() {
        this.getRecapMalware();
      },
    },
    startDate: {
      handler() {
        this.getRecapMalware();
      },
    },
    statInterval: {
      handler() {
        this.getRecapMalware();
      },
    },
    statSandbox: {
      handler() {
        this.getRecapMalware();
      },
    },
  },
  methods: {
    // getPreferences() {
    //   this.loading.recap = true;
    //   let ferr = 0;
    //   PreferencesServices.getByKey("elastic", "ahn_lab")
    //     .then((response) => {
    //       if (response.status == 201) {
    //         let new_token = response.data.refresh_access_token;
    //         userService.splitToken(new_token);
    //         this.getPreferences();
    //         ferr = 1;
    //         this.$store.dispatch("notification/refreshtoken", "refresh");
    //       } else {
    //         ferr = 2;
    //         this.totalUser = [];
    //         this.pref_ahn = response.data.data;
    //       }
    //     })
    //     .catch((err) => {
    //       if (err.response == undefined) {
    //         console.log("err ->> ", err);
    //       } else if (
    //         this.$store.state.notification.type === "refresh-token" &&
    //         err.response.status == 401
    //       ) {
    //         this.getPreferences();
    //       } else {
    //         if (err.response.status == 401) {
    //           userService.logout();
    //         } else {
    //           console.log(err);
    //         }
    //       }
    //     })
    //     .finally(() => {
    //       // this.getCheckpoint();
    //     });
    // },

    // getPreferencesCP() {
    //   let ferr = 0;
    //   PreferencesServices.getByKey("elastic", "checkpoint")
    //     .then((response) => {
    //       if (response.status == 201) {
    //         let new_token = response.data.refresh_access_token;
    //         userService.splitToken(new_token);
    //         this.getPreferences();
    //         ferr = 1;
    //         this.$store.dispatch("notification/refreshtoken", "refresh");
    //       } else {
    //         ferr = 2;
    //         this.totalUser = [];
    //         this.pref_cp = response.data.data;
    //       }
    //     })
    //     .catch((err) => {
    //       if (err.response == undefined) {
    //         console.log("err ->> ", err);
    //       } else if (
    //         this.$store.state.notification.type === "refresh-token" &&
    //         err.response.status == 401
    //       ) {
    //         this.getPreferencesCP();
    //       } else {
    //         if (err.response.status == 401) {
    //           userService.logout();
    //         } else {
    //           console.log(err);
    //         }
    //       }
    //     })
    //     .finally(() => {
    //       this.getCheckpoint();
    //     });
    // },

    // getRecap() {
    //   this.series_all = [];
    //   this.malwareRecapitulation.categories = [];
    //   this.malwareRecapitulation.series[0].data = [];
    //   this.malwareRecapitulation.series[1].data = [];
    //   this.malwareRecapitulation.series[2].data = [];
    //   this.malwareRecapitulation.series[3].data = [];
    //   this.malwareRecapitulation.series[4].data = [];
    //   this.malwareRecapitulation.series[5].data = [];

    //   const ordered = _.orderBy(this.sandBoxData, (res) => res.index_time);
    //   const grouped = _.groupBy(ordered, "index_time");

    //   _.map(_.values(grouped), (arr) => {
    //     let tempData = {
    //       office_file: 0,
    //       archives: 0,
    //       enc_key: 0,
    //       prog: 0,
    //       db: 0,
    //       other: 0,
    //     };
    //     let allType = [
    //       ...this.category[0].data,
    //       ...this.category[1].data,
    //       ...this.category[2].data,
    //       ...this.category[3].data,
    //       ...this.category[4].data,
    //     ];
    //     arr.forEach((el) => {
    //       this.category.forEach((item) => {
    //         if (item.data.includes(el.type)) {
    //           tempData[item.name] += 1;
    //         }
    //       });
    //       if (!allType.includes(el.type)) {
    //         tempData["other"] += 1;
    //       }
    //     });
    //     this.malwareRecapitulation.series[0].data.push(tempData.office_file);
    //     this.malwareRecapitulation.series[1].data.push(tempData.archives);
    //     this.malwareRecapitulation.series[2].data.push(tempData.enc_key);
    //     this.malwareRecapitulation.series[3].data.push(tempData.prog);
    //     this.malwareRecapitulation.series[4].data.push(tempData.db);
    //     this.malwareRecapitulation.series[5].data.push(tempData.other);

    //     this.series_all.push(tempData);
    //     this.malwareRecapitulation.categories.push(arr[0].index_time);
    //   });

    //   setTimeout(() => {
    //     this.loading.recap = false;
    //   }, 500);
    // },

    // getCheckpoint() {
    //   this.loading.recap = true;
    //   this.sandBoxData = [];
    //   if (this.statSandbox == "all" || this.statSandbox == "checkpoint") {
    //     let bodyQuery = {
    //       size: 100,
    //       query: {
    //         bool: {
    //           filter: [],
    //           should: [],
    //           must_not: [],
    //         },
    //       },
    //     };

    //     if (this.statInterval == "7d") {
    //       const optQuery = {
    //         bool: {
    //           filter: [
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       index_time: {
    //                         gt: moment()
    //                           .subtract(7, "days")
    //                           .format("YYYY-MM-DD"),
    //                         time_zone: "Asia/Jakarta",
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       index_time: {
    //                         lte: moment().add(1, "days").format("YYYY-MM-DD"),
    //                         time_zone: "Asia/Jakarta",
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //           ],
    //         },
    //       };
    //       bodyQuery.query.bool.filter.push(optQuery);
    //     }
    //     if (this.statInterval == "30d") {
    //       const optQuery = {
    //         bool: {
    //           filter: [
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       index_time: {
    //                         gt: moment()
    //                           .subtract(30, "days")
    //                           .format("YYYY-MM-DD"),
    //                         time_zone: "Asia/Jakarta",
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       index_time: {
    //                         lte: moment().add(1, "days").format("YYYY-MM-DD"),
    //                         time_zone: "Asia/Jakarta",
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //           ],
    //         },
    //       };
    //       bodyQuery.query.bool.filter.push(optQuery);
    //     }
    //     if (this.statInterval == "90d") {
    //       const optQuery = {
    //         bool: {
    //           filter: [
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       index_time: {
    //                         gt: moment()
    //                           .subtract(90, "days")
    //                           .format("YYYY-MM-DD"),
    //                         time_zone: "Asia/Jakarta",
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       index_time: {
    //                         lte: moment().add(1, "days").format("YYYY-MM-DD"),
    //                         time_zone: "Asia/Jakarta",
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //           ],
    //         },
    //       };
    //       bodyQuery.query.bool.filter.push(optQuery);
    //     }
    //     if (this.pref_cp.username && this.pref_cp.password) {
    //       let us = this.pref_cp.username;
    //       let ps = this.pref_cp.password;
    //       let base = this.encode(us, ps);
    //       var basedata_cp = "Basic " + base + "";
    //     } else {
    //       var basedata_cp = null;
    //     }

    //     ElasticService.getCheckpointLab(
    //       this.pref_cp.api_host,
    //       bodyQuery,
    //       basedata_cp
    //     )
    //       .then((response) => {
    //         // console.log('recap cp',  response.data.hits.hits);
    //         response.data.hits.hits.forEach((ele) => {
    //           const item = {
    //             index_time: moment(ele._source.detect_time).format(
    //               "DD-MM-YYYY"
    //             ),
    //             type: ele._source.file_type,
    //           };
    //           this.sandBoxData.push(item);
    //         });
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       })
    //       .finally(() => {
    //         this.getAhnLab();
    //       });
    //   } else {
    //     this.getAhnLab();
    //   }
    // },

    // getAhnLab() {
    //   if (this.statSandbox == "all" || this.statSandbox == "ahn_lab") {
    //     let bodyQuery = {
    //       size: 100,
    //       query: {
    //         bool: {
    //           filter: [],
    //           should: [],
    //           must_not: [],
    //         },
    //       },
    //     };

    //     if (this.statInterval == "7d") {
    //       const optQuery = {
    //         bool: {
    //           filter: [
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       "detect_time.keyword": {
    //                         gt: moment()
    //                           .subtract(7, "days")
    //                           .format("YYYY-MM-DD"),
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       "detect_time.keyword": {
    //                         lte: moment().add(1, "days").format("YYYY-MM-DD"),
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //           ],
    //         },
    //       };
    //       bodyQuery.query.bool.filter.push(optQuery);
    //     }
    //     if (this.statInterval == "30d") {
    //       const optQuery = {
    //         bool: {
    //           filter: [
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       "detect_time.keyword": {
    //                         gt: moment()
    //                           .subtract(30, "days")
    //                           .format("YYYY-MM-DD"),
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       "detect_time.keyword": {
    //                         lte: moment().add(1, "days").format("YYYY-MM-DD"),
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //           ],
    //         },
    //       };
    //       bodyQuery.query.bool.filter.push(optQuery);
    //     }
    //     if (this.statInterval == "90d") {
    //       const optQuery = {
    //         bool: {
    //           filter: [
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       "detect_time.keyword": {
    //                         gt: moment()
    //                           .subtract(90, "days")
    //                           .format("YYYY-MM-DD"),
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //             {
    //               bool: {
    //                 should: [
    //                   {
    //                     range: {
    //                       "detect_time.keyword": {
    //                         lte: moment().add(1, "days").format("YYYY-MM-DD"),
    //                       },
    //                     },
    //                   },
    //                 ],
    //                 minimum_should_match: 1,
    //               },
    //             },
    //           ],
    //         },
    //       };
    //       bodyQuery.query.bool.filter.push(optQuery);
    //     }

    //     if (this.pref_ahn.username && this.pref_ahn.password) {
    //       let us = this.pref_ahn.username;
    //       let ps = this.pref_ahn.password;
    //       let base = this.encode(us, ps);
    //       var basedata_ahn = "Basic " + base + "";
    //     } else {
    //       var basedata_ahn = null;
    //     }
    //     // console.log("ahn host", this.pref_ahn.api_host);
    //     ElasticService.getAhnLab(
    //       this.pref_ahn.api_host,
    //       bodyQuery,
    //       basedata_ahn
    //     )
    //       .then((response) => {
    //         response.data.hits.hits.forEach((ele) => {
    //           const item = {
    //             index_time: moment(ele._source.detect_time).format(
    //               "DD-MM-YYYY"
    //             ),
    //             type: ele._source.file_type,
    //           };
    //           this.sandBoxData.push(item);
    //         });
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       })
    //       .finally(() => {
    //         this.getRecap();
    //       });
    //   } else {
    //     this.getRecap();
    //   }
    // },

    // encode(us, ps) {
    //   let usps = us + ":" + ps;
    //   return Buffer.from(usps).toString("base64");
    //   // console.log('hsl', usps, hsl);
    // },

    getRecapMalware() {
      this.loading.recap = true;
      // console.log("get recap");
      let ferr = 0;
      const params = {
        int: this.statInterval,
        start_date: this.formatDateAnalyzed(this.startDate),
        end_date: this.formatDateAnalyzed(this.endDate),
        sandbox: this.statSandbox,
      };
      // console.log("params analyzed", params);
      StatisticsService.getMalwareRecap(params)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getRecapMalware();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.loading.recap = false;
            this.malware_type = [];
            this.malware_type_series = {
              series: [
                {
                  name: "Total",
                  data: [],
                },
              ],
            };

            ferr = 2;
            // console.log("res", response.data.data);
            response.data.data.forEach((event, index) => {
              const data = {
                x: event.filetype,
                y: event.total,
              };

              if (event.filetype) {
                this.malware_type.push(event.filetype);
              }
              this.malware_type_series.series[0].data.push(data);
              // this.totalUser.push(data);
              // this.loading = false;
            });
            this.malware_type_series.series[0].name = "Total";
          }
        })
        .catch((err) => {
          this.loading.recap = false;
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getRecapMalware();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    formatDateAnalyzed(value) {
      return moment(value).format("YYYYMMDD");
    },

    changeType(type) {
      this.charttype = type;
    },
  },
  beforeMount() {
    this.getRecapMalware();
  },
  mounted() {
    // this.getPreferences();
    // this.getPreferencesCP();
    // this.getRecapMalware();
  },
};
</script>
>
